import * as dateFns from 'date-fns';
import {getUTCDate} from '@deezer/next/shared/utils/date';

export const MIN_DATE = dateFns.startOfDay(dateFns.subYears(getUTCDate(), 1));
export const MAX_DATE = dateFns.endOfDay(dateFns.subDays(getUTCDate(), 1));
